import axios from 'axios';

const defaultOptions = {
  baseURL: process.env.VUE_APP_API_BASE_URL,
};
const authorizationHeader = process.env.VUE_APP_AUTHORIZATION_HEADER || 'Authorization';

const instance = axios.create(defaultOptions);

instance.interceptors.request.use(
  (config) => {
    if (!config.headers[authorizationHeader] && !!localStorage.getItem('token')) {
      const newToken = localStorage.getItem('token');
      // eslint-disable-next-line no-param-reassign
      config.headers[authorizationHeader] = newToken;
    }

    return config;
  },
  (error) => { Promise.reject(error); },
);

// instance.interceptors.response.use(undefined, (error) => new Promise(() => {
//   // eslint-disable-next-line no-underscore-dangle
//   if (error.status === 403) {
//     this.$store.dispatch('auth/logout');
//     this.$router.push('/login');
//   }
// }));
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 403) {
      // this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
);

export default instance;
